import LOGO from '@/assets/imgs/logo.png';
  // 设计娱乐
import GITEE from '@/assets/imgs/media/gitee.png'
import ZHIHU from '@/assets/imgs/media/zhihu.png'
import EMAIL from '@/assets/imgs/media/email.png'
import GITHUB from '@/assets/imgs/media/github.png'
import WECHAT from '@/assets/imgs/media/wechat.png'
import WEIBO from '@/assets/imgs/media/weibo.png'
import BOKEYUAN from '@/assets/imgs/media/bokeyuan.png'
import LEETCODE from '@/assets/imgs/media/leetcode.png'
import SEGMENTFAULT from '@/assets/imgs/media/segmentfault.png'


const CONFIG = {
    TITLE:"半片叶の小窝",
    LOGO:LOGO,
    MOTTO:"博观而约取  厚积而薄发",
    MAXIM:"☰ 潜龙在渊  凤栖于巢",
    AUTHOR:"半片叶",
    ADMINCODE:'cxfye',
    SECRETARTICLES:['战国策.md', '写在27岁生日.md', '写给你的.md', '2020年9月的一点想法.md'],
    COPYRIGHT:"By @Half Leaf  " +  new Date().getFullYear(),
    MEDIAS:[
        {
          icon:GITHUB,
          name:'Github',
          link:"https://github.com/HalfLeaf"
        },
        {
          icon:GITEE,
          name:'Gitee',
          link:"https://gitee.com/half-leaf"
        },
        {
          icon:LEETCODE,
          name:'LeetCode',
          link:"https://leetcode-cn.com/u/half-leaf/"
        },
        {
          icon:SEGMENTFAULT,
          name:'SegmentFault 思否',
          link:"https://segmentfault.com/u/yewei_cxf"
        },
        {
          icon:BOKEYUAN,
          name:'博客园',
          link:"https://www.cnblogs.com/halfleaf/"
        },
        {
          icon:ZHIHU,
          name:'知乎',
          link:"https://www.zhihu.com/people/xie-wei-luo-2"
        },
        {
          icon:EMAIL,
          name:'个人邮箱',
          link:"mailto:ye944205791@163.com"
        },
        {
          icon:WECHAT,
          name:'微信',
          link:"/wechat"
        },
        {
          icon:WEIBO,
          name:'微博',
          link:"https://weibo.com/5910192655/profile?topnav=1&wvr=6&is_all=1"
        },
    ],
}

export default CONFIG